import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HotjarMasked from '../HotjarMasked';

class SelectInput extends Component {
  renderSelect() {
    const {
      name,
      onChange,
      defaultOption,
      optionsGroupLabel,
      disabled,
      value,
      options,
      classes = null
    } = this.props;

    return (
      <select
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`form-control ${classes}`}
      >
        {optionsGroupLabel && (
          <optgroup label={optionsGroupLabel}>
            {defaultOption && <option value="">{defaultOption}</option>}
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.text}
              </option>
            ))}
          </optgroup>
        )}

        {!optionsGroupLabel &&
        defaultOption && <option value="">{defaultOption}</option>}
        {!optionsGroupLabel &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
      </select>
    );
  }

  render() {
    const { name, label, error, classes = null, hotjarMasked } = this.props;

    return (
      <div className="form-group">
        {label && (
          <label className={`control-label ${classes}`} htmlFor={name}>
            {label}
          </label>
        )}
        <div className="field">
          {hotjarMasked && <HotjarMasked>{this.renderSelect()}</HotjarMasked>}
          {!hotjarMasked && this.renderSelect()}
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </div>
    );
  }
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultOption: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  classes: PropTypes.string,
  optionsGroupLabel: PropTypes.string,
  hotjarMasked: PropTypes.bool
};

export default SelectInput;
